import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router';
import AccountSettings from './accountSettings/AccountSettings';
import Products from './products/Products';
import Invoices from './invoices/Invoices';
import Auditing from './auditing/Auditing';
import CompanySettings from './companySettings/CompanySettings';
import SplashScreen from '../splashScreen/SplashScreen';

const Account = () => {
    return (
        <Suspense fallback={<SplashScreen />}>
            <Routes>
                <Route path="/" element={<AccountSettings />} />
                <Route path="configuration" element={<CompanySettings />} />
                <Route path="auditing" element={<Auditing />} />
                <Route path="products" element={<Products />} />
                <Route path="invoices" element={<Invoices />} />
            </Routes>
        </Suspense>
    );
};

export default Account;